import React from "react";
import CONFIG from "../../config";

function Audience(props) {
    return (
        <React.Fragment>
            <div className="advert-audience position-relative">
                <div className="card p-xxl-5 p-lg-4 p-md-3 p-0 w-100 border-0" style={{ background: "url(https://yuppstatic.akamaized.net/yupptv/yupptv_new/Web/minified/Content/images/advertise/audience.png) no-repeat center center", backgroundSize: "cover"}}>
                    <div className="banner-overlay-ad"/>
                    <div className="card-body p-xxl-5 p-3 text-center">
                        <h1 className="ff-ember-rg">A Great Brand starts with the Right Audience.</h1>
                        <br/>
                        <h5 className="ff-ember-rg text-secondary">{CONFIG.APP_NAME} retains a massive user base in all the major countries of the world. The larger your Business is, the better we can serve you.</h5>
                    </div>
                </div>
            </div>
            <div className="row mt-xl-5 mt-5 pt-xxl-5 pt-md-3 pt-0 justify-content-md-between justify-content-center align-items-center text-md-start text-center">
                <div className='col-lg-5 col-md-7 col-12 order-md-1 order-2'>
                    <h2 className="ff-ember-rg mb-4">
                        Target where it matters
                    </h2>
                    <h4 className="ff-ember-lt my-4 pt-xxl-5 pt-md-4 pt-3 text-static-title">Location specific ads</h4>
                    <p className="h5 ff-ember-lt">Reach your potential audience by targeting specific Country, Region, or City.</p>
                </div>
                <div className='col-lg-4 col-md-4 col-8 text-center order-md-2 order-1 mb-md-0 mb-5'>
                    <img src="https://yuppstatic.akamaized.net/yupptv/yupptv_new/Web/minified/Content/images/advertise/audience-iphone.png" className="w-100"/>
                </div>
            </div>
            <br/>
            <div className="row mt-xl-5 mt-5 pt-xxl-5 pt-md-3 pt-0 justify-content-md-between justify-content-center align-items-center text-md-start text-center">
                <div className='col-lg-4 col-md-4 col-8 text-center mb-md-0 mb-5'>
                    <img src="https://yuppstatic.akamaized.net/yupptv/yupptv_new/Web/minified/Content/images/advertise/audience-mac.png" className="w-100"/>
                </div>
                <div className='col-lg-5 col-md-7 col-12'>
                    <h2 className="ff-ember-rg mb-4">
                        Influence with Language
                    </h2>
                    <h4 className="ff-ember-lt my-4 pt-xxl-5 pt-md-4 pt-3 text-static-title">Language Specific Ads</h4>
                    <p className="h5 ff-ember-lt">Advertise in Channels from 14+ languages.</p>
                </div>
            </div>
            <br/>
            <div className="row mt-xl-5 mt-5 pt-xxl-5 pt-md-3 pt-0 justify-content-md-between justify-content-center align-items-center text-md-start text-center">
                <div className='col-lg-5 col-md-7 col-12 order-md-1 order-2'>
                    <h2 className="ff-ember-rg mb-4">
                        Advertise where it matters
                    </h2>
                    <h4 className="ff-ember-lt my-4 pt-xxl-5 pt-md-4 pt-3 text-static-title">Advertise on our Top Content</h4>
                    <p className="h5 ff-ember-lt">And Across a Whole Collection of Web Originals, Sports, Movies, and YuppTV's very own Online Streaming Channels Bollywood Box Office (BBO), Kollywood Box Office (KBO), Malayalam Box Office (MBO) and Telugu Box Office (TBO)</p>
                </div>
                <div className='col-lg-4 col-md-4 col-8 text-center order-md-2 order-1 mb-md-0 mb-5'>
                    <img src="https://yuppstatic.akamaized.net/yupptv/yupptv_new/Web/minified/Content/images/advertise/audience-iphone.png" className="w-100"/>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Audience;